const initialState = {
  context: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SET_CONTEXT":
      return {
        ...state,
        context: action.payload,
      };
    default:
      return state;
  }
};
